import { Controller } from "@hotwired/stimulus"

// landing v2 — แท็บบนมือถือ (ราศี/ลัคนา, แพ็กราคา): ปุ่มที่ n โชว์ panel ที่ n
// เดสก์ท็อปซ่อนแถบแท็บและโชว์ทุก panel ด้วย CSS (.lv-seg / .on) — controller แค่สลับคลาส on
export default class extends Controller {
  static targets = ["panel"]

  show({ params: { index }, currentTarget }) {
    currentTarget.parentElement.querySelectorAll("button").forEach((b) => {
      b.classList.toggle("on", b === currentTarget)
      b.setAttribute("aria-selected", b === currentTarget)
    })
    this.panelTargets.forEach((p, j) => p.classList.toggle("on", j === index))
  }
}
